<div class="form-well">
    <form class="formly" role="form" [formGroup]="form" (ngSubmit)="process()">
        <formly-form [model]="model" [fields]="fields" [form]="form">
        </formly-form>
        <div class="btn-group" role="group">
            <button
                type="submit"
                class="btn btn-primary"
                [disabled]="form.invalid || !isValidInput"
            >
                Save
            </button>
        </div>
    </form>
</div>
